import { useTranslation } from 'react-i18next';

interface SystemRoleBadgeProps {
  systemRole: boolean;
}

/**
 * 시스템 4역할 여부를 나타내는 뱃지 컴포넌트.
 * 시스템 역할에는 자물쇠 아이콘 + "시스템" 레이블 표시.
 * 커스텀 역할에는 "커스텀" 레이블 표시.
 */
export function SystemRoleBadge({ systemRole }: SystemRoleBadgeProps) {
  const { t } = useTranslation();

  if (systemRole) {
    return (
      <span
        title={t('role.list.systemBadge.tooltip')}
        aria-label={t('role.list.systemBadge.ariaLabel', { defaultValue: '시스템 기본 역할' })}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 'var(--spacing-1)',
          padding: '2px var(--spacing-2)',
          background: 'color-mix(in srgb, var(--color-warning) 15%, var(--color-surface-elevated))',
          border: '1px solid var(--color-warning)',
          borderRadius: 'var(--radius-full)',
          fontSize: 'var(--font-size-xs)',
          fontWeight: 600,
          color: 'var(--color-warning)',
          whiteSpace: 'nowrap',
        }}
      >
        <span aria-hidden="true" style={{ fontSize: '10px' }}>🔒</span>
        {t('role.list.systemBadge.label')}
      </span>
    );
  }

  return (
    <span
      aria-label={t('role.list.customBadge.ariaLabel', { defaultValue: '커스텀 역할' })}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-1)',
        padding: '2px var(--spacing-2)',
        background: 'color-mix(in srgb, var(--color-info) 12%, var(--color-surface-elevated))',
        border: '1px solid var(--color-info)',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--font-size-xs)',
        fontWeight: 600,
        color: 'var(--color-info)',
        whiteSpace: 'nowrap',
      }}
    >
      {t('role.list.customBadge.label')}
    </span>
  );
}
